(function(){
  var input=document.getElementById('z-search-input');
  var box=document.getElementById('z-pred-results');
  if(!input||!box)return;
  var t;
  function hide(){box.innerHTML='';box.classList.remove('has');}
  function run(q){
    var url='/search/suggest?q='+encodeURIComponent(q)+'&section_id=zaada-predictive&resources[type]=product,query&resources[limit]=8&resources[options][unavailable_products]=last';
    fetch(url,{headers:{'Accept':'text/html'}}).then(function(r){return r.text();}).then(function(html){
      box.innerHTML=html;box.classList.add('has');
    }).catch(function(){});
  }
  input.addEventListener('input',function(){var q=this.value.trim();clearTimeout(t);if(q.length<2){hide();return;}t=setTimeout(function(){run(q);},180);});
  input.addEventListener('keydown',function(e){if(e.key==='Escape'){hide();}});
  document.addEventListener('click',function(e){var tog=e.target.closest('[data-search-toggle]');if(!tog)return;setTimeout(function(){var s=document.querySelector('.z-search');if(s&&s.classList.contains('open')){input.focus();}else{hide();}},70);});
})();
